// Hội thoại trong expand row: bình luận gốc + các trả lời + ô trả lời inline
import React from "react";
import { Button, Tag, Tooltip, Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faCheck } from "@fortawesome/free-solid-svg-icons";
import UserCell from "./user-cell";
import ReplyBox from "./reply-box";
import { fmtTime } from "../helpers";

export default function CommentThread({ record, submitting, onReply, onDeleteReply, onApproveReply }) {
    return (
        <div className="flex flex-col gap-3 pl-2 py-1">
            {record.replies?.length ? (
                <div className="flex flex-col gap-2">
                    {record.replies.map((r) => (
                        <div
                            key={r.id}
                            className="flex items-start justify-between gap-3 border-b border-line pb-2"
                        >
                            <div className="flex-1">
                                <UserCell user={r.user} />
                                <div className="text-sm text-content-2 mt-1">
                                    {/* Reply chờ duyệt (status=0) chưa hiển thị công khai */}
                                    {r.status === 0 && <Tag color="red">Chờ duyệt</Tag>}
                                    {r.comment}
                                </div>
                                <div className="text-xs text-content-3">{fmtTime(r.createTime)}</div>
                            </div>
                            <Space size={4}>
                                {r.status === 0 && (
                                    <Tooltip title="Duyệt trả lời (hiển thị công khai)">
                                        <Button
                                            size="small"
                                            type="primary"
                                            icon={<FontAwesomeIcon icon={faCheck} />}
                                            onClick={() => onApproveReply(r.id)}
                                        />
                                    </Tooltip>
                                )}
                                <Button
                                    size="small"
                                    danger
                                    icon={<FontAwesomeIcon icon={faTrash} />}
                                    onClick={() => onDeleteReply(r.id)}
                                />
                            </Space>
                        </div>
                    ))}
                </div>
            ) : (
                <span className="text-content-3 text-xs">Chưa có trả lời</span>
            )}

            <ReplyBox
                submitting={submitting}
                onSubmit={(text) => onReply(record.commentId, text)}
            />
        </div>
    );
}
